import { render, staticRenderFns } from "./block-repairer-totals.vue?vue&type=template&id=0d8719d3&scoped=true"
import script from "./block-repairer-totals.vue?vue&type=script&lang=js"
export * from "./block-repairer-totals.vue?vue&type=script&lang=js"
import style0 from "./block-repairer-totals.vue?vue&type=style&index=0&id=0d8719d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8719d3",
  null
  
)

export default component.exports